import React, {Fragment, useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import {marcarPrestamoIncobrable, mostrarPrestamoById} from '../../redux/reducers/prestamosReducer';
import {mostrarClienteById} from "../../redux/reducers/clientesReducer";

import {formatDate, formatPeso, hasPermissionTo, moment, PERSMISOS, translateText,} from '../../helpers';
import {
  Box,
  Button,
  ButtonGroup,
  DialogContentText,
  Divider,
  Grid,
  Hidden,
  Menu,
  MenuItem,
  Paper,
  Rating,
  Theme,
  Typography,
  useMediaQuery
} from '@mui/material';
import {ArrowDropDown, KeyboardArrowDown, MoreHoriz} from '@mui/icons-material';

import ListPagos from '../../components/listPagos'
import ListAmort from '../../components/listAmort'
import {AppBar, HtmlTooltip, LoadingProgress} from "../../components";
import {MODAL_EXPORT_TYPE} from "./ContratoDialog";
import AjustarCapitalDialog from "./AjustarCapitalDialog";
import CancelDialog from './CancelDialog'
import HacerPago from './addPago'
import ContactDetails from "../clientes/ContactDetails";
import Strings from "../../assets/strings";
import NoImg from '../../assets/img/defaultAvatar.jpg';
import {useCustomFormInput} from "../../hooks/useCustomFormInput";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ConfCamposType} from "../../redux/types/ICompania";
import {ESTADO_PRESTAMO, getValueString, SITUACION_PRESTAMO} from "../../helpers/CONSTANTES";
import ListNotas from "../../components/listNotas";
import estadoPrestamo from "../../styles/estadoPrestamo";
import ConfirmDialog from "../../components/ConfirmDialog";

const useStyles = makeStyles((theme:Theme) => ({
  clientAvatar: {
    textAlign: "center",
    padding: 20,
    border: "1px solid #ddd",
    height: 138,
    [theme.breakpoints.down('md')]: {
      textAlign: "left",
      padding: "9px 16px 8px",
      border: "none",
      background: theme.palette.primary.main,
      color:"white",
      display: "flex",
      justifyContent: "start",
      top: 50,
      alignItems: "center",
      height: "auto",
      position: "fixed",
      width: "100%",
      zIndex: 1,


      borderBottom:"2px solid transparent",

      "&.estado3, &.estado4":{//ANULADO
        borderBottom: "2px solid #d84315",
      },
      "&.estado5":{//REENGANCHADO
        borderBottom: "2px solid #15d2d8",
      },
      "&.situacion4":{//CUOTASVENCIDA
        borderBottom: "2px solid #d84315",
      },
      "&.situacion3":{//mora
        borderBottom: "2px solid #ff6f00",
      },
      "&.situacion2":{ //pendiente
        borderBottom: "2px solid #1976d2",
      },
    },



  },
  imgCont:{
    width: 100,
    height: 100,
    marginBottom:8,
    margin: "0 auto",
    position: "relative",
    [theme.breakpoints.down('md')]: {
      margin: "0",
      marginRight: theme.spacing(2),
      height: 45,
      width: 45,
      "& img":{
        width: 45,
        height: 45,
      }
    },

  },
  contentInner:{
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  estadoRating:{
    [theme.breakpoints.down('md')]: {
      display:"flex",
    },

  },
  estado:{
    marginTop: 10,
    textAlign: "center",
    height: 16,
    padding: "7px 14px",
    background: "#eceeef",
    [theme.breakpoints.down('md')]: {
      // marginTop: 0,
      // marginBottom:theme.spacing(1),
      display:"none",
    },
    ...estadoPrestamo(theme),
  },
  imgCircle: {
    borderRadius: "50%",
    [theme.breakpoints.down('md')]: {
      borderRadius: theme.shape.borderRadius,
    },
  },
  controls:{
    paddingTop: 10,
    overflowX: 'auto',
    boxShadow: "none",
    borderRadius: 0,
    "& > div":{
      // minWidth: 479,
    },
    "& a , button:not(:first-child)":{
      // textTransform: "capitalize",
      fontWeight: "normal",
      fontSize: ".9rem",
    },
    [theme.breakpoints.down('xl')]: {
      textAlign: "center",
    }
  },
  table: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(3),
    },
    marginBottom: 35,
  },
  button: {
    // marginLeft: theme.spacing(1),
    color:"inherit",
    background: "#f5f5f5",
    padding: "3px 9px",
    marginLeft: 3,

  },
  info:{
    overflowX: "auto",
    overflowY: "hidden",

    padding: 10,
    [theme.breakpoints.up('md')]: {
      background:"#eceeef",
      padding: 6,
      boxShadow: "none",
      borderRadius: 0,
      "&:not(.all)":{
        height: 167,
      },
      "&>div":{
        minWidth: 785,
      }
    },
    position: "relative",
    [theme.breakpoints.down('md')]: {
      padding: 0,
      margin: "66px 0 0 0px",
      borderRadius: "0",
      boxShadow: "none"
    },
  },
  itemInfo:{
    //...theme.typography.subheading,
    padding: "10px !important",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    [theme.breakpoints.down('md')]: {
      display: "flex",
      flexDirection: "column-reverse",
      padding: "5px 16px !important",
    },
    "& span:last-child":{
      background: "#f6f6f6",
      padding: "5px 13px",
      marginLeft: 10,
      [theme.breakpoints.down('md')]: {
        background: "none",
        marginLeft: 0,
        padding: 0,
        fontSize: "0.9rem",
      },
    },
    "& span:first-child":{
      [theme.breakpoints.down('md')]: {
        display: "block",
        fontSize: ".7rem",
      },
    }
  },
  topBar:{
    display: "flex",
    justifyContent: "end",
    background: "#edeeef",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      background: theme.palette.primary.main+" !important",
      marginBottom: "0px !important",
      position: "fixed",
      width: "100%",
      zIndex: 1,
      "& *":{
        color:theme.palette.common.white,
      },
    },
  },
  btnMoreInfo:{
    position:"absolute",
    right:theme.spacing(2),
    cursor:"pointer",
  },
  moreInfo:{
    background:theme.palette.grey[100],
    "& span":{
      fontSize: 15,
    }
  },
  cancelBox:{
    "& .title":{
      background: "#ffdede",
    },
    "& textarea":{
      width: "calc(100% - 7px)",
      border: "1px solid #e6e6e6",
      resize: "none",
    },
    "& .content":{
      padding: "10px 10px 0 10px",
    }
  },
  contGrid:{
    [theme.breakpoints.down('md')]: {
      padding: "0px !important",
      margin: "0px !important",
    },
  },
  btnPagoRapido:{
    position: "absolute",
    width: 170,
    bottom: 10,
    right: 10
  },
  notaNumber:{
    background: "#b5b5b5",
    fontSize: "10px !important",
    width: 18,
    height: 18,
    borderRadius: 9,
    color: "white"
  }
}));


export default function DetallesPrestamo() {
  let navigate = useNavigate();
  const {state:hState={},pathname} = useLocation();

  let dispatch = useAppDispatch();
  let {byId:prestamo={}, status} = useAppSelector(state => state.prestamos);

  const customFormInput = useCustomFormInput("prestamo") as ConfCamposType;

  let { preId } = useParams();

  const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
  const classes = useStyles();
  const [showAllInfo, setShowAllInfo] = useState(false);

  const [tableTab, setTableTab] = useState(1);
  const [openMenu, setOpenMenu] = useState<null | HTMLElement>(null);

  useEffect(() => {
    if (preId)
      dispatch(mostrarPrestamoById(parseInt(preId)));
  }, [dispatch, preId]);
  const pushUrl = (state:any)=>{
    if(openMenu)setOpenMenu(null);
    navigate(pathname,{state});
  };
  const showClientModal = (cliId:number) => {
    dispatch(mostrarClienteById(cliId));
    pushUrl({cliente: {cliId}});
  }
  const onClickPendiente = (v:any) => {
    pushUrl({modalPago: v})
  }

  const [printMenu, setPrintMenu] = React.useState<null | HTMLElement>(null);

  const anchorRef = React.useRef<HTMLDivElement>(null);

  return (
      <>
        <AppBar title={Strings.detalles}/>
        <div className={"contentInner "+classes.contentInner}>
          {status === "loading" && <LoadingProgress vh/>}
            <Grid container spacing={smVewport?0:2}>
              <Grid item xs={12} md={3}>
                <div className={classes.clientAvatar+" estado"+prestamo.estado+" situacion"+prestamo.situacion}  onClick={()=>showClientModal(prestamo.clienteId!)}>
                  <div className={classes.imgCont}>
                    <img height="100" width="100" alt="Avatar" src={prestamo.clienteAvatar ? prestamo.clienteAvatar: NoImg} className={classes.imgCircle} />
                  </div>
                  <div>
                    <Typography  noWrap={true} color="inherit">{prestamo.cliente}</Typography>
                    <div className={classes.estadoRating}>
                      <Hidden mdUp>
                        {prestamo.estado === ESTADO_PRESTAMO.ACTIVO ? (
                            <>{getValueString(SITUACION_PRESTAMO, prestamo.situacion)}</>
                        ):(
                            <>{getValueString(ESTADO_PRESTAMO, prestamo.estado)}</>
                        )}

                        {(prestamo.estado === ESTADO_PRESTAMO.ACTIVO && prestamo.situacion === SITUACION_PRESTAMO.CUOTAS_VENCIDA) && ": "+prestamo.cuotasAtrasadas}
                      </Hidden>
                      <Box display={"flex"} alignItems="center" justifyContent="center">
                        <Rating value={prestamo.clienteCalificacion || 0} precision={0.5} size="small" readOnly/> &nbsp;
                        <Typography variant={"caption"}>{prestamo.clienteCalificacion}</Typography>
                      </Box>
                    </div>
                  </div>
                </div>
                <div className={classes.estado +" estado"+prestamo.estado+" situacion"+prestamo.situacion}>
                  {prestamo.estado === ESTADO_PRESTAMO.ACTIVO ? (
                      <>{getValueString(SITUACION_PRESTAMO, prestamo.situacion)}</>
                  ):(
                      <>{getValueString(ESTADO_PRESTAMO, prestamo.estado)}</>
                  )}

                  {/*{(prestamo.cuotasAtrasadas??0)>0 && ": "+prestamo.cuotasAtrasadas}*/}
                  {(prestamo.estado === ESTADO_PRESTAMO.ACTIVO && prestamo.situacion === SITUACION_PRESTAMO.CUOTAS_VENCIDA) && ": "+prestamo.cuotasAtrasadas}
                </div>
              </Grid>
              <Grid item xs={12} md={9}>
                <div className={(showAllInfo?"all":"")+" "+classes.info} onClick={()=>{if(!(window as any).getSelection().toString()) setShowAllInfo(!showAllInfo);}}>
                  <Grid container >
                    {!showAllInfo && <MoreHoriz className={classes.btnMoreInfo}/>}
                    {showAllInfo &&
                        <Grid item xs={12} className={classes.moreInfo}>
                          <Grid container>
                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>ID:</span>
                              <span>{prestamo.id}</span>
                            </Grid>
                            {!!prestamo.inicial &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.inicial} {Strings.pendiente}:</span>
                                  <span>{formatPeso(prestamo.inicial)}</span>
                                </Grid>
                            }
                            {!!prestamo.prestamoIdReenganche &&
                                <Grid item xs={4}  className={classes.itemInfo} onClick={()=>navigate("/prestamo/"+prestamo.prestamoIdReenganche)}>
                                  <span>{Strings.reenganche}:</span>
                                  <span style={{textDecoration: "underline",cursor:"pointer",color: "#2b50d6"}}>{prestamo.prestamoIdReenganche}</span>
                                </Grid>
                            }
                            {!!prestamo.referencia &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.codigoRef}:</span>
                                  <span>{prestamo.referencia}</span>
                                </Grid>
                            }
                            <Grid item xs={4}  className={classes.itemInfo}>
                              <span>{Strings.fechaApertura}:</span>
                              <span>{formatDate(prestamo.fecha)}</span>
                            </Grid>
                            {!!prestamo.codeudor &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.codeudor}:</span>
                                  <span>{prestamo.codeudor}</span>
                                </Grid>
                            }
                            {!!prestamo.diasExcluidos &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.diasExcluidos}:</span>
                                  <span>
                              {prestamo.diasExcluidos.split(",")
                                  .map(s=>moment().day(s).format("dd")).join(', ')}
                            </span>
                                </Grid>
                            }
                            {!!prestamo.caja &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.caja}:</span>
                                  <Typography noWrap component={"span"}>{prestamo.caja}</Typography>
                                </Grid>
                            }
                            {/*{!!prestamo.fechaActualizacion &&*/}
                            {/*    <Grid item xs={4}  className={classes.itemInfo}>*/}
                            {/*      <span>{Strings.editado}:</span>*/}
                            {/*      <span>{formatDate(prestamo.fechaActualizacion)}</span>*/}
                            {/*    </Grid>*/}
                            {/*}*/}
                            {/*{!!prestamo.creadoPor &&*/}
                            {/*    <Grid item xs={4}  className={classes.itemInfo}>*/}
                            {/*      <span>{Strings.creadoPor}:</span>*/}
                            {/*      <span>{prestamo.creadoPor}</span>*/}
                            {/*    </Grid>*/}
                            {/*}*/}

                            {customFormInput && Object.keys(customFormInput).map((key)=><Fragment key={key}>
                              {(prestamo as any)["campo"+key.slice(-1)] &&
                                  <Grid item xs={4}  className={classes.itemInfo}>
                                    <span>{customFormInput[key].name}:</span>
                                    <span>{(prestamo as any)["campo"+key.slice(-1)]}</span>
                                  </Grid>
                              }
                            </Fragment>)}
                            {!!prestamo.porcientoComision &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.agente}:</span>
                                  <span>{prestamo.porcientoComision}</span>
                                </Grid>
                            }
                            {!!prestamo.cartera &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.cartera}:</span>
                                  <Typography noWrap component={"span"}>{prestamo.cartera}</Typography>
                                </Grid>
                            }
                            {!!prestamo.montoSeguro &&
                                <Grid item xs={4}  className={classes.itemInfo}>
                                  <span>{Strings.seguro}:</span>
                                  <Typography noWrap component={"span"}>{prestamo.montoSeguro}</Typography>
                                </Grid>
                            }
                          </Grid>
                        </Grid>
                    }
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>{Strings.capitalActual}:</span>
                      <span>{formatPeso(prestamo.capitalActual)}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>{Strings.cuotas}:</span>
                      <span>{prestamo.plazoString}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>{Strings.amortizacion}:</span>
                      <span>{translateText(prestamo.tipoAmortizacionString)}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>{Strings.proximo} {Strings.pago}:</span>
                      <Typography noWrap component={"span"}>{formatDate(prestamo.fechaProximoPago,"dd, DD/MM/YYYY")}</Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.itemInfo}>
                      <span>{Strings.interes}:</span>
                      <span>{prestamo.tasaInteres} %</span>
                    </Grid>

                    <Grid item xs={4}  className={classes.itemInfo}>
                      <span>{Strings.capitalInicial}:</span>
                      <span>{formatPeso(prestamo.capitalInicial)}</span>
                    </Grid>
                    <Grid item xs={4}  className={classes.itemInfo+(prestamo.balancePendiente?" text-red-deep":"")}>
                      <HtmlTooltip title={Strings.cuotaVencida +"+"+ Strings.mora}>
                        <Typography noWrap component={"span"}>
                          {Strings.balancePendiente}
                        </Typography>
                      </HtmlTooltip>
                      <span>{formatPeso(prestamo.balancePendiente)}</span>
                    </Grid>
                    <Grid item xs={4} className={classes.itemInfo}>
                      <span>{Strings.modalidad}:</span>
                      <span>{translateText(prestamo.ciclosPagoString)}</span>
                    </Grid>

                    <Grid item xs={4} className={classes.itemInfo}>
                      <span>{Strings.mora}:</span>
                      <span>% {prestamo.porcientoMora}</span>
                    </Grid>
                    {/*<Grid item xs={4}  className={classes.itemInfo}>*/}
                    {/*  <span>{Strings.parcialPendiente}:</span>*/}
                    {/*  <span>{formatPeso(prestamo.prePagoPendiente)}</span>*/}
                    {/*</Grid>*/}
                    <Grid item xs={4} className={classes.itemInfo}>
                      <span>{Strings.comision}:</span>
                      <span>%{prestamo.porcientoComision}</span>
                    </Grid>
                    <Grid item xs={4} className={classes.itemInfo}>
                      <span>{Strings.gastosLegales}:</span>
                      <span>{prestamo.gastosLegales}</span>
                    </Grid>
                    {!!prestamo.diasAtraso &&
                        <Grid item xs={4} className={classes.itemInfo+" text-red-deep"}>
                          <span>Atraso:</span>
                          {/*<span>*/}
                          {/*  {prestamo.diasAtraso}*/}
                          {/*</span>*/}
                          {getAtraso(prestamo.diasAtraso, prestamo.ciclosPago!)}

                        </Grid>
                    }
                  </Grid>
                </div>
                <Hidden only={"xs"}>
                  <Paper className={"d-print-none " +classes.controls}>
                    <div style={{minWidth: 867, paddingBottom: 3}}>
                      {hasPermissionTo(PERSMISOS.pagosCrear) &&
                          <Button disableElevation size={"small"} onClick={() => pushUrl({modalPago: {prestamoId:prestamo.id}})}
                                  disabled={!!prestamo.fechaCancelacion || prestamo.estado === ESTADO_PRESTAMO.INCOBRABLE}
                                  color={"primary"} variant={"contained"}>{Strings.agregar} {Strings.pago}</Button>
                      }

                      {!prestamo.fechaCancelacion && prestamo.estado !== ESTADO_PRESTAMO.INCOBRABLE && <>
                        {hasPermissionTo(PERSMISOS.prestamosActualizar) &&
                            <Button size="small" className={classes.button} component={Link} to={`/editar/prestamo/${prestamo.id}`}> {Strings.editar}</Button>
                        }
                        {hasPermissionTo(PERSMISOS.prestamosEliminar) &&
                            <Button size="small" color="secondary" className={"text-red "+classes.button}
                                    onClick={()=> pushUrl({modalCancel:prestamo.id})}>{Strings.anular}</Button>
                        }
                        {hasPermissionTo(PERSMISOS.prestamosAjustes) &&
                            <Button size="small" className={classes.button}
                                    onClick={() => pushUrl({modalAjustar: prestamo.id})}>{Strings.ajustar} {Strings.capital}</Button>
                        }
                        {hasPermissionTo(PERSMISOS.prestamosCrear) &&
                            <Button size="small"  className={classes.button} component={Link} to={`/reenganche/${prestamo.id}`}> {Strings.reenganche}</Button>
                        }
                      </>}
                      {!prestamo.fechaCancelacion &&
                          <Button size="small" className={classes.button}
                                  onClick={()=> pushUrl({modalIncobrable: true })}
                          >
                            {prestamo.estado === ESTADO_PRESTAMO.INCOBRABLE ? "Marcar cobrable" : "Incobrable"}
                          </Button>
                      }

                      <Button size="small" className={classes.button}
                              onClick={(e)=>setPrintMenu(e.currentTarget)}
                              endIcon={<KeyboardArrowDown />}
                      >{Strings.imprimir}</Button>


                      <Button size="small" className={classes.button}
                              onClick={()=>navigate(pathname, {state: {...hState, contactar:{
                                    prestamoId: prestamo.id,
                                    nombres: prestamo.cliente,
                                    celular: prestamo.clienteCelular,
                                    email: prestamo.clienteEmail,
                                  }}})}
                      >{Strings.contactar}</Button>
                    </div>
                  </Paper>

                  <Menu
                      anchorEl={printMenu}
                      open={Boolean(printMenu)}
                      onClose={()=>setPrintMenu(null)}
                  >
                    <MenuItem onClick={()=> {
                      pushUrl({modalExport: {id: preId, type: MODAL_EXPORT_TYPE.CONTRATO}});
                      setPrintMenu(null)
                    } }>{Strings.imprimir} {Strings.contrato}</MenuItem>
                    <MenuItem onClick={()=> {
                      pushUrl({modalExport: {id: preId, type: MODAL_EXPORT_TYPE.DETALLE_PRESTAMO}});
                      setPrintMenu(null)
                    } }>{Strings.imprimir} {Strings.estado}</MenuItem>

                    {/*<MenuItem  onClick={()=> openNewWin("/reports/contrato/" + preId)}>*/}
                    {/*  {Strings.imprimir} {Strings.contrato}*/}
                    {/*</MenuItem>*/}


                  </Menu>
                </Hidden>
              </Grid>
              <Hidden smUp>

                <ButtonGroup variant="contained" ref={anchorRef} fullWidth aria-label="split button" sx={{m:1,mb:0}}>
                  <Button onClick={()=> pushUrl({modalPago:{prestamoId:prestamo.id}})}
                          disabled={!!prestamo.fechaCancelacion || prestamo.estado === ESTADO_PRESTAMO.INCOBRABLE || !hasPermissionTo(PERSMISOS.pagosCrear)}
                          >{Strings.agregar} {Strings.pago}</Button>
                  <Button
                      size="small"
                      aria-haspopup="menu"
                      onClick={(e)=>setOpenMenu(e.currentTarget)}
                      sx={{width: "54px"}}
                  >
                    <ArrowDropDown />
                  </Button>
                </ButtonGroup>
                <Menu id="long-menu" anchorEl={openMenu} keepMounted open={Boolean(openMenu)} onClose={()=>setOpenMenu(null)}>
                  {!prestamo.fechaCancelacion && prestamo.estado !== ESTADO_PRESTAMO.INCOBRABLE && (hasPermissionTo(PERSMISOS.prestamosActualizar)) &&
                      <MenuItem component={Link} to={`/editar/prestamo/${prestamo.id}`}>{Strings.editar}</MenuItem>
                  }

                  {!prestamo.fechaCancelacion && prestamo.estado !== ESTADO_PRESTAMO.INCOBRABLE && hasPermissionTo(PERSMISOS.prestamosAjustes) &&
                      <MenuItem onClick={()=> pushUrl({modalAjustar:prestamo.id})}>{Strings.ajustar} {Strings.capital}</MenuItem>
                  }
                  {!prestamo.fechaCancelacion && prestamo.estado !== ESTADO_PRESTAMO.INCOBRABLE && hasPermissionTo(PERSMISOS.prestamosCrear) &&
                      <MenuItem  component={Link} to={`/reenganche/${prestamo.id}`}> {Strings.reenganche}</MenuItem>
                  }
                  {!prestamo.fechaCancelacion &&
                      <MenuItem
                          onClick={()=> pushUrl({modalIncobrable: true })}
                      >
                        {prestamo.estado === ESTADO_PRESTAMO.INCOBRABLE? "Marcar cobrable":"Incobrable"}
                      </MenuItem>
                  }
                  {!prestamo.fechaCancelacion && prestamo.estado !== ESTADO_PRESTAMO.INCOBRABLE && hasPermissionTo(PERSMISOS.prestamosEliminar) &&
                      <MenuItem className={"text-red"} onClick={()=> pushUrl({modalCancel:prestamo.id})}>{Strings.anular} {Strings.prestamo}</MenuItem>
                  }
                  <Divider/>
                  <MenuItem  onClick={()=> pushUrl({modalExport:{id: preId, type: MODAL_EXPORT_TYPE.CONTRATO}})}>
                    {Strings.imprimir} {Strings.contrato}
                  </MenuItem>

                  <MenuItem onClick={()=> pushUrl({modalExport:{id: preId, type: MODAL_EXPORT_TYPE.DETALLE_PRESTAMO}})}>
                    {Strings.imprimir} {Strings.estado}
                  </MenuItem>
                  <Divider/>
                  <MenuItem onClick={()=>navigate(pathname, {state: {...hState, contactar:{
                                prestamoId: prestamo.id,
                                nombres: prestamo.cliente,
                                celular: prestamo.clienteCelular,
                                email: prestamo.clienteEmail
                              }}})}
                  >{Strings.contactar}</MenuItem>

                </Menu>
              </Hidden>
            </Grid>
            <div className={classes.table}>
              {tableTab === 1 && <ListPagos notasCount={prestamo?.notas?.length} onTabClick={setTableTab} onClickPendiente={onClickPendiente} showSeguro={!!prestamo.montoSeguro} pagos={prestamo.pagos?prestamo.pagos:[]} />}
              {tableTab === 2 && <ListAmort notasCount={prestamo?.notas?.length} onTabClick={setTableTab} data={prestamo.amortizacion??[]}/>}
              {tableTab === 3 && <ListNotas notasCount={prestamo?.notas?.length} onTabClick={setTableTab} data={prestamo.notas??[]}/>}
            </div>


        </div>


        {!!hState?.modalPago?.prestamoId && <HacerPago/>}



        {!!hState?.cliente && <ContactDetails/>}
        {!!hState?.modalAjustar && <AjustarCapitalDialog/>}
        {!!hState?.modalCancel && <CancelDialog/>}
        {!!hState?.modalIncobrable && <ConfirmDialog open={true} mode={"warning"} onConfirm={()=>dispatch(marcarPrestamoIncobrable(prestamo.id!))} >
          <DialogContentText>
            ¿Desear marcar este préstamo como {prestamo.estado === ESTADO_PRESTAMO.INCOBRABLE? "COBRABLE":"INCOBRABLE"} ?
          </DialogContentText>
        </ConfirmDialog>}


      </>
  );


}

function getAtraso(diasAtraso:number, ciclosPago:number) {
  let cuotas = Math.floor(diasAtraso / ciclosPago!);
  let cuotasRemanente = (diasAtraso / ciclosPago!) % 1;

  let dias = 0;
  if(cuotasRemanente !== 0){
    dias =  diasAtraso - (cuotas * ciclosPago)
  }

  return (
      <span>
        {cuotas} cuotas &nbsp;
        {dias > 0 &&
          <>y {dias} días</>
        }
      </span>
  )
}
